import Response from "@/services/api/Response";
import ServerError from "@/services/errorHandler/types/ServerError";
import logger from "@/services/Logger";
import axios from "axios";

// TODO:

/**
 * Request priority
 * - low
 * - medium
 * - high
 */

export default class Request {
  constructor(name) {
    this.name = name;
  }
  send(url, { data = {}, method = "get", options }) {
    return axios[method](url, data, options)
      .then(({ data = {} }) => {
        return new Response(data);
      })
      .then(response => {
        const {
          code,
          status,
          exception,
          trace,
          message,
          payload = {}
        } = response;

        logger.request({
          from: "API",
          title: `${method.toUpperCase()}: ${this.name.toUpperCase()} ${url}`,
          request: data,
          response
        });

        if (code >= 400 && code < 600) {
          throw new ServerError({
            message: message || payload.message || `Get ${code} from server`,
            code,
            exception,
            trace,
            status
          });
        }

        return response;
      })
      .catch(error => {
        throw error.isAxiosError
          ? new ServerError({
              message: error.message,
              code: error.response ? error.response.status : null,
              stack: error.stack
            })
          : error;
      });
  }
  post(url, params = {}, options = {}) {
    return this.send(url, { data: params, method: "post", options });
  }
  delete(url, params = {}, options = {}) {
    return this.send(url, { data: params, method: "delete", options });
  }
  get(url, params = {}, options = {}) {
    return this.send(url, { data: { params }, options });
  }
}
